import React, { Component } from "react";
import { EMBEDFUL_STATS } from "../../../constants";

const CHART_BARS = [38, 52, 46, 64, 58, 76, 68];

class Showcase extends Component {
  scrollToFeatures = (e) => {
    e.preventDefault();
    const target = document.getElementById("embedful-features");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  renderStats() {
    let stats = EMBEDFUL_STATS.map(({ label, value }) => {
      return (
        <div key={`stat ${label}`} className="device-stat">
          <span className="device-stat-label">{label}</span>
          <span className="device-stat-value">{value}</span>
        </div>
      );
    });

    return stats;
  }

  renderBars() {
    let bars = CHART_BARS.map((height, index) => {
      return (
        <span
          key={`bar ${index}`}
          className="device-chart-bar"
          style={{ height: `${height}%` }}
        ></span>
      );
    });

    return bars;
  }

  render() {
    return (
      <section id="embedful">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 embedful-copy">
              <span className="embedful-eyebrow anim_piece">
                Founder Project <span className="embedful-eyebrow-sep">/</span>{" "}
                SaaS Product
              </span>

              <h2 className="anim_piece">Embedful</h2>

              <p className="embedful-headline anim_piece">
                Launch customer dashboards in minutes.
              </p>

              <p className="anim_piece">
                Embedful helps SaaS teams turn their existing data into
                secure, customer-facing dashboards that can be embedded
                directly into their product, without the complexity of
                building an analytics platform from scratch.
              </p>

              <div className="embedful-block anim_piece">
                <h5 className="embedful-block-title">The Problem</h5>
                <p>
                  Customer analytics can quickly turn into a major
                  engineering project. Data access, tenant isolation,
                  dashboard UI, permissions, embedding, exports, and
                  infrastructure all need to be built and maintained.
                </p>
              </div>

              <p className="embedful-solution anim_piece">
                Embedful packages those pieces into a simpler workflow so
                teams can focus on their product instead of building
                dashboard infrastructure.
              </p>

              <div className="embedful-cta anim_piece">
                <a
                  href="https://embedful.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-dark-green waves-effect"
                >
                  Visit Embedful
                </a>
                <a
                  href="#"
                  onClick={this.scrollToFeatures}
                  className="btn btn-outline-dark-green waves-effect"
                >
                  Learn More
                </a>
              </div>
            </div>

            <div className="col-12 col-md-6 embedful-visual-col">
              <div className="embedful-visual anim_piece">
                <div className="device-frame">
                  <div className="device-frame-bar">
                    <span className="device-dot"></span>
                    <span className="device-dot"></span>
                    <span className="device-dot"></span>
                    <span className="device-url">
                      app.yourproduct.com/analytics
                    </span>
                  </div>
                  <div className="device-frame-body">
                    <div className="device-frame-header">
                      <span className="device-frame-label">
                        Customer Analytics
                      </span>
                      <span className="device-frame-badge">
                        Live &middot; Embedded with Embedful
                      </span>
                    </div>
                    <div className="device-stats">{this.renderStats()}</div>
                    <div className="device-chart">{this.renderBars()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Showcase;
